import { Navigate, useLocation } from 'react-router-dom';

import { PATH } from '../widget-lib/path-routes';

export function TrainerIndexRedirect() {
  const location = useLocation();
  return <Navigate to={{ pathname: PATH.trainerWorkSchedule, search: location.search }} replace />;
}
